// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/index." + {"151":"2cdb9ab73942dfee8cd8","162":"426b43067678e4745b3c","293":"aba8c993b685b82e0539","751":"dd3bdc1839541a89d926","847":"9bbdfe4d7b77c67f9bc1","852":"4f49066f28773326141a"}[chunkId] + ".js";
};